import React, { useEffect, useState } from 'react';
import {
  Grid,
  TextField,
  Autocomplete,
  CircularProgress,
  Box,
} from '@mui/material';
import axios from 'axios';

const UserAllServices = () => {
  const [userRoles] = useState([
    'CHANNELPARTNER',
    'SUPERDISTRIBUTOR',
    'MASTERDISTRIBUTOR',
    'AREADISTRIBUTOR',
    'RETAILER',
  ]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  
  // Fetch users based on selected role
  const fetchUsersByRole = async (role) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://api.ipaisa.co.in/myapp/admin/getAllPartner?userrole=${role}`
      );
      setUsers(response.data);
    } catch (error) {
      console.error('Error fetching users:', error);
      setUsers([]); // Clear users on error
    } finally {
      setLoading(false);
    }
  };

  // Handle role selection change
  const handleRoleChange = (event, newValue) => {
    setSelectedRole(newValue);
    if (newValue) {
      fetchUsersByRole(newValue);
    } else {
      setUsers([]); // Clear users if no role is selected
    }
  };

  return (
    <Box style={{ padding: '2rem', marginTop: '5%' }}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Autocomplete
            options={userRoles}
            onChange={handleRoleChange}
            renderInput={(params) => (
              <TextField {...params} label="Select User Role" variant="outlined" />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Autocomplete
            options={users}
            getOptionLabel={(option) => `${option.Name} - ${option.userId}` || ''}
            loading={loading}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select User"
                variant="outlined"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loading ? <CircularProgress color="inherit" size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
            onChange={(event, newValue) => {
              if (newValue) {
                console.log('Selected User ID:', newValue.userId); // Log the userId
              }
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default UserAllServices;
